{
  "clinicalNotes": "Clinical Notes",
  "noteType": "Note Type",
  "author": "Author",
  "dateTime": "Date/Time",
  "content": "Content",
  "addNote": "Add Note",
  "editNote": "Edit Note",
  "signNote": "Sign Note",
  "signed": "Signed",
  "unsigned": "Unsigned",
  "types": {
    "progressNote": "Progress Note",
    "admissionNote": "Admission Note",
    "dischargeNote": "Discharge Note",
    "consultNote": "Consultation Note",
    "procedureNote": "Procedure Note"
  },
  "editor": {
    "newNote": "New Note",
    "titlePlaceholder": "Note title…",
    "create": "Create",
    "cancel": "Cancel",
    "cosignFilterLabel": "Show Notes Needing My Co-sign",
    "emptyNoCosign": "No notes needing your co-sign",
    "emptyNoNotes": "No notes yet",
    "emptySelection": "Select a note or create a new one",
    "emptySelectionHint": "Choose from the list on the left or click \"+ New Note\" to begin.",
    "unknownAuthor": "Unknown",
    "needsCosignBadge": "Needs Co-sign",
    "amendmentBanner": "Amendment of note #{{parentId}} — Reason: {{reason}}",
    "signedBanner": "Signed by {{name}} on {{when}} — This note is read-only.",
    "signedByFallback": "provider",
    "saving": "Saving...",
    "autoSaved": "Auto-saved",
    "actions": {
      "saveDraft": "Save Draft",
      "signNote": "Sign Note",
      "amend": "Amend",
      "cosign": "Co-sign",
      "printLabel": "Print Note"
    },
    "copyForward": "Copy last note forward",
    "copyForwardHint": "Carries the signed note from {{date}} — review and update every line",
    "copiedForwardBadge": "Copied forward"
  },
  "dialog": {
    "sign": {
      "title": "Sign Note",
      "body": "Are you sure you want to sign this note? This action cannot be undone. The note will become read-only after signing.",
      "cancel": "Cancel",
      "confirm": "Confirm Sign"
    },
    "amend": {
      "title": "Amend Note",
      "body": "Please provide a reason for this amendment. The note will be updated and marked as amended.",
      "reasonPlaceholder": "Amendment reason…",
      "cancel": "Cancel",
      "confirm": "Confirm Amend"
    },
    "cosign": {
      "title": "Co-sign Note",
      "body": "Are you sure you want to co-sign this note? This confirms that you have reviewed and agree with the content of this note.",
      "cancel": "Cancel",
      "confirm": "Confirm Co-sign"
    }
  },
  "toast": {
    "created": "Note created",
    "createFailed": "Failed to create note",
    "titleRequired": "Please enter a note title",
    "draftSaved": "Draft saved",
    "signed": "Note signed successfully",
    "signFailed": "Failed to sign note",
    "amended": "Note amended successfully",
    "amendFailed": "Failed to amend note",
    "amendReasonRequired": "Please provide an amendment reason",
    "cosigned": "Note co-signed successfully",
    "cosignFailed": "Failed to co-sign note"
  },
  "status": {
    "draft": "Draft",
    "unsigned": "Unsigned",
    "signed": "Signed",
    "amended": "Amended",
    "cosigned": "Co-signed",
    "cosignNeeded": "Co-sign Needed",
    "pendingSignature": "Pending Signature",
    "addendum": "Addendum",
    "cosignPending": "Co-sign Pending"
  },
  "worklist": {
    "title": "Unsigned Notes Worklist",
    "backToDashboard": "Dashboard",
    "filtersHeading": "Filters",
    "filterAllNoteTypes": "All Note Types",
    "filterAllStatuses": "All Statuses",
    "filterAuthorPlaceholder": "Filter by author…",
    "dateFromAria": "Note date from",
    "dateToAria": "Note date to",
    "columns": {
      "patient": "Patient",
      "mrn": "MRN",
      "noteType": "Note Type",
      "noteTitle": "Title",
      "author": "Author",
      "created": "Created",
      "status": "Status",
      "actions": "Actions"
    },
    "actions": {
      "signSelected": "Sign Selected ({{count}})",
      "signing": "Signing…",
      "open": "Open",
      "refresh": "Refresh"
    },
    "loading": "Loading notes…",
    "empty": "No unsigned notes found",
    "loadError": "Failed to load unsigned notes",
    "retry": "Retry",
    "toast": {
      "noneSelected": "No notes selected",
      "signed_one": "{{count}} note signed successfully",
      "signed_other": "{{count}} notes signed successfully",
      "signFailed": "Failed to sign some notes",
      "partiallySigned_one": "{{count}} note signed, {{failed}} failed to sign",
      "partiallySigned_other": "{{count}} notes signed, {{failed}} failed to sign"
    }
  },
  "type": {
    "progress": "Progress Note",
    "historyPhysical": "H&P",
    "admission": "Admission Note",
    "discharge": "Discharge Summary",
    "consult": "Consultation",
    "procedure": "Procedure Note",
    "operative": "Operative Note",
    "nursing": "Nursing Note"
  },
  "template": {
    "list": {
      "title": "Note Templates",
      "backToDashboard": "Dashboard",
      "newButton": "New Template",
      "columns": {
        "name": "Name",
        "noteType": "Note Type",
        "specialty": "Specialty",
        "sections": "Sections",
        "status": "Status",
        "actions": "Actions"
      },
      "active": "Active",
      "inactive": "Inactive",
      "loading": "Loading templates…",
      "empty": "No templates found. Create one to get started.",
      "previewTitle": "Template Preview: {{name}}",
      "emptySection": "(empty)",
      "tooltips": {
        "preview": "Preview",
        "edit": "Edit",
        "activate": "Activate",
        "deactivate": "Deactivate"
      },
      "toast": {
        "statusUpdated": "Template status updated"
      }
    },
    "form": {
      "editTitle": "Edit Template",
      "createTitle": "Create Template",
      "fields": {
        "name": "Template Name",
        "noteType": "Note Type",
        "specialty": "Specialty",
        "sections": "Sections"
      },
      "required": "*",
      "namePlaceholder": "e.g., Standard Progress Note",
      "selectNoteType": "Select type…",
      "selectSpecialty": "Select specialty…",
      "addSection": "Add Section",
      "sectionNamePlaceholder": "Section name (e.g., Chief Complaint)",
      "sectionDefaultPlaceholder": "Default content for this section…",
      "cancel": "Cancel",
      "create": "Create Template",
      "update": "Update Template",
      "toast": {
        "created": "Template created",
        "updated": "Template updated",
        "saveFailed": "Failed to save template",
        "nameAndTypeRequired": "Name and note type are required",
        "atLeastOneSection": "At least one section is required"
      }
    },
    "specialty": {
      "general": "General",
      "internalMedicine": "Internal Medicine",
      "surgery": "Surgery",
      "pediatrics": "Paediatrics",
      "cardiology": "Cardiology",
      "neurology": "Neurology",
      "orthopedics": "Orthopaedics",
      "emergencyMedicine": "Emergency Medicine"
    },
    "scope": {
      "personal": "Personal",
      "group": "Group",
      "global": "Global"
    },
    "state": {
      "draft": "Draft",
      "published": "Published"
    }
  },
  "components": {
    "clinicalNoteEditor": {
      "bold": "Bold",
      "italic": "Italic",
      "list": "List",
      "templates": "Templates / Smart Phrases",
      "saved": "Saved {{time}}",
      "notSaved": "Not saved",
      "charactersLabel": "characters",
      "save": "Save {{noteType}}",
      "placeholder": "Begin typing your {{noteType}}… Use \".\" to trigger smart phrases.",
      "smartPhrases": {
        "patientName": "Patient Name",
        "mrn": "MRN",
        "dateOfBirth": "Date of Birth",
        "allergies": "Allergies",
        "vitals": "Vitals",
        "medications": "Medications",
        "problemList": "Problem List"
      }
    }
  }
}
